<template>
  <div class="image-by-map" v-show="params.flag">
    <div class="image-player">
      <div class="product-name">{{ params.productInfo.name }}</div>
      <div class="time-node">
        <div
          :class="{ node: true, active: currentIndex === index }"
          v-for="(item, index) in times"
          :key="item"
          @mouseover="handleMouseover(index)"
        >
          <i class="el-icon-loading" v-show="!loaded[index]"></i>
        </div>
      </div>
      <div class="show-time">
        {{ $moment(times[currentIndex]).format("HH:mm") }}
      </div>
      <el-button
        type="primary"
        :class="{
          'play-bn': true,
          'play-stop': timeout !== '',
          'el-icon-caret-right': timeout === '',
        }"
        @click="togglePlay"
      >
      </el-button>
      <el-button
        type="primary"
        class="play-bn el-icon-refresh-right"
        @click="init"
      >
      </el-button>
      <el-dropdown @command="(command) => (interval = command)">
        <el-button type="primary" class="speeds-select-bn">
          {{ interval }} s<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="0.2">0.2s</el-dropdown-item>
          <el-dropdown-item command="0.5">0.5s</el-dropdown-item>
          <el-dropdown-item command="0.8">0.8s</el-dropdown-item>
          <el-dropdown-item command="1">1s</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div
      class="legend"
      v-show="params.productInfo && params.productInfo.code === 'A01'"
    >
      <div class="name">回波强度</div>
      <div class="nbarwrap">
        <div class="nbar">
          <span class="node">5</span><span class="node">10</span
          ><span class="node">15</span><span class="node">20</span
          ><span class="node">25</span><span class="node">30</span
          ><span class="node">35</span><span class="node">40</span
          ><span class="node">45</span><span class="node">50</span
          ><span class="node">55</span><span class="node">60</span
          ><span class="node">65</span><span class="node">70</span>
        </div>
        <div class="nbar bottom">
          <span class="node" style="background-color: rgb(0, 236, 236)"></span
          ><span class="node" style="background-color: rgb(0, 160, 224)"></span
          ><span class="node" style="background-color: rgb(0, 0, 246)"></span
          ><span class="node" style="background-color: rgb(0, 254, 0)"></span
          ><span class="node" style="background-color: rgb(0, 200, 0)"></span
          ><span class="node" style="background-color: rgb(0, 144, 0)"></span
          ><span class="node" style="background-color: rgb(254, 254, 0)"></span
          ><span class="node" style="background-color: rgb(230, 192, 0)"></span
          ><span class="node" style="background-color: rgb(254, 144, 0)"></span
          ><span class="node" style="background-color: rgb(254, 0, 0)"></span
          ><span class="node" style="background-color: rgb(167, 0, 0)"></span
          ><span class="node" style="background-color: rgb(100, 0, 0)"></span
          ><span class="node" style="background-color: rgb(254, 0, 254)"></span
          ><span
            class="node"
            style="background-color: rgb(152, 84, 200)"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jsonData } from "../api/index";
import ImageLayer from "ol/layer/Image";
import ImageStatic from "ol/source/ImageStatic";
import XYZ from "ol/source/XYZ";
import TileLayer from "ol/layer/Tile";
const baseUrl = process.env.VUE_APP_BASE_URL;
export default {
  props: ["params"],
  data() {
    return {
      interval: 1,
      // key为产品的code值
      products: {
        A01: {
          extent: [108.5, 18.2, 119, 27],
          path: "/radarpic/",
        },
        A04: {
          extent: [54.3, -5, 159.6, 66],
          path: "/cloud/3D/",
        },
      },
      currentIndex: 0,
      times: [],
      images: [],
      loaded: [],
      layer: "",
      timeout: "",
      refreshTime: "",
    };
  },
  watch: {
    /**
     * 监听当前索引，切换图层
     * @param {Number} index
     */
    currentIndex(index) {
      this.setSource(index);
    },
    "params.flag": {
      handler(newVal) {
        if (newVal) {
          if (this.params.productInfo.code === "A01") {
            this.$parent.selectedNavs.includes("A04") &&
              this.$parent.toggleProductView("A04");
          } else {
            this.$parent.selectedNavs.includes("A01") &&
              this.$parent.toggleProductView("A01");
          }
          this.layer && this.layer.setVisible(true);
          if (this.refreshTime) {
            clearInterval(this.refreshTime);
          }
          this.refreshTime = setInterval(() => {
            this.init();
          }, 360 * 1000);
          this.togglePlay();
        } else {
          this.layer && this.layer.setVisible(false);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.init();
  },

  mounted() {
    this.timmer && clearInterval(this.timmer);
    this.timmer = setInterval(() => {
      this.init();
    }, 5000 * 60);
  },
  methods: {
    /**
     * 初始化
     */
    async init() {
      // if (this.timeout !== '') {
      //   clearTimeout(this.timeout)
      //   this.timeout = ''
      // }
      const code = this.params.productInfo.code;
      const data = await this.getData();
      if (this.params.productInfo.code === "A01") {
        this.times = data.times;
        this.loaded = new Array(this.times.length).fill(true);
      } else {
        this.times = data.times.reverse();
        const images = data.images.reverse();
        // const basUrl = this.params.productInfo.code === 'A1' ? process.env.VUE_APP_DATA : process.env.VUE_APP_BASE_API
        for (let index = images.length - 1; index >= 0; index--) {
          const image = new Image();
          image.src =
            process.env.VUE_APP_DATA + this.products[code].path + images[index];
          image.onload = () => {
            this.$set(this.loaded, index, true);
          };
          this.images[index] = image.src;
        }
      }
      this.currentIndex = this.times.length - 1;
    },
    /**
     * 设置图片叠加到地图
     */
    setSource(index) {
      if (this.layer === "") {
        const opacity = this.params.productInfo.code === "A01" ? 0.7 : 0.3;
        if (this.params.productInfo.code === "A01") {
          this.layer = new TileLayer({
            zIndex: 10,
            opacity,
          });
        } else {
          this.layer = new ImageLayer({
            zIndex: 10,
            opacity,
          });
        }
        this.params.map2d.map.addLayer(this.layer);
      }
      if (this.params.productInfo.code === "A01") {
        const time = this.times[index];
        const timeStr = this.$moment(time).format("YYYYMMDDHHmmss");
        const url = `${baseUrl}/data/radar_cut/${timeStr}/{z}/{x}/{y}.png`;
        if (!this.layer.getSource()) {
          const source = new XYZ({
            url: url,
            minZoom: 6,
            maxZoom: 11,
          });
          this.layer.setSource(source);
        } else {
          this.layer.getSource().setUrl(url);
        }
      } else {
        const source = new ImageStatic({
          url: this.images[index],
          imageExtent: this.products[this.params.productInfo.code].extent,
        });
        this.layer.setSource(source);
      }
    },
    /**
     * 获取数据
     */
    getData() {
      const code = this.params.productInfo.code;
      switch (code) {
        case "A01":
          return jsonData.getRadarImages();
        case "A04":
          return jsonData.getCloudData();
      }
    },
    /**
     * 切换播放暂停
     */
    togglePlay() {
      if (this.timeout === "") {
        this.play();
      } else {
        clearTimeout(this.timeout);
        this.timeout = "";
      }
    },
    /**
     * 播放
     */
    play() {
      if (this.timeout !== "") {
        clearTimeout(this.timeout);
        this.timeout = "";
      }
      this.timeout = setTimeout(() => {
        const index = this.currentIndex + 1;
        if (index === this.times.length) {
          this.currentIndex = 0;
        } else {
          this.currentIndex = index;
        }
        this.play();
      }, this.interval * 1000);
    },
    /**
     *
     */
    handleMouseover(index) {
      this.currentIndex = index;
      if (this.timeout !== "") {
        clearTimeout(this.timeout);
        this.timeout = "";
      }
    },
  },
  beforeDestroy() {
    this.timmer && clearInterval(this.timmer);
  },
};
</script>
<style lang="less" scoped>
.image-by-map {
  position: absolute;
  left: 50vw;
  bottom: calc(9vh + 0.31vw);
  transform: translateX(-50%);
  color: #fff;
  box-sizing: border-box;
  // padding-right: 1vw;
  background: url("../assets/images/radar-bg.png") no-repeat;
  background-size: 100% 100%;

  // border-image: linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5)) 1 1;
  .image-player {
    display: flex;
    align-items: center;
    padding: 0.42vw 0.83vw 0.31vw 0.73vw;

    .product-name {
      color: #fff;
      width: 3.33vw;
      font-size: 0.68vw;
      font-weight: 600;
      margin-right: 0.63vw;
    }

    .time-node {
      display: flex;

      .node {
        height: 1.2rem;
        width: 0.52vw;
        background: #207dd0;
        border-radius: 0.12rem;
        margin-right: 0.2rem;
        cursor: pointer;
        opacity: 0.3;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-icon-loading {
          color: #fff;
          font-size: 0.7rem;
        }
      }

      .node.active {
        background: #7dc5ff;
      }
    }

    .show-time {
      color: #fff;
      background: #526788;
      border-radius: 0.25rem;
      font-size: 0.8rem;
      text-align: center;
      min-width: 2rem;
      line-height: 1.5rem;
      padding: 0 0.5rem;
      margin: 0 0.5rem;
      white-space: nowrap;
    }

    .play-bn {
      padding: 0;
      height: 1.5rem;
      width: 1.5rem;
      border-radius: 0.3rem;
      margin: 0 0.5rem 0 0;
      border: none;
      background: #48adff;
      color: #fff;
      font-size: 1.25rem;
    }

    .play-stop::before {
      content: "";
      display: block;
      width: 0.7rem;
      height: 0.7rem;
      margin: 0 auto;
      background-color: #fff;
    }

    .speeds-select-bn {
      background: #48adff;
      color: #fff;
      width: 4.4rem;
      line-height: 1.5rem;
      padding: 0 0.5rem;

      i {
        font-size: 0.8rem;
      }
    }
  }

  .legend {
    display: flex;
    align-items: center;
    color: #fff;
    border-top: 0.05vw solid #526077;
    padding: 0.1vw 0.68vw 0.31vw 0.78vw;

    .name {
      color: #fff;
      width: 3.33vw;
      font-size: 0.68vw;
      margin-right: 0.63vw;
      font-weight: 600;
    }

    .nbarwrap {
      .nbar {
        display: flex;
        flex-direction: row;
        justify-content: left;
        font-size: 0.8rem;

        .node {
          display: inline-block;
          // height: 1.5rem;
          line-height: 1.2rem;
          width: 1.5rem;
          text-align: center;
        }
      }

      .nbar.bottom {
        .node {
          height: 0.7rem;
        }
      }
    }
  }
}
</style>
